import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { MACHINES_MAIN_SCREEN, machinesComponentsConfig } from './config';
import { MachinesScreen } from '@v2/pages/machines/common/enums';
import { BOTTOM_SHEET_OPTIONS, NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';
import { BatchDetailsScreenName } from '@v2/pages/batch/details/navigation/config';
import { NCFileDetailsScreenName } from '@v2/pages/nc-file/details/navigation/config';
import { PartDetailsScreenName } from '@v2/pages/part/details/navigation/config';
import { JobDetailsScreenName } from '@v2/pages/job/navigation/config';
import { ToolsDetailsScreenName } from '@v2/pages/tools/details/navigation/config';
import { BatchDetailsNavigator } from '@v2/pages/batch/details/navigation/BatchDetailsNavigator';
import { NCFileDetailsNavigator } from '@v2/pages/nc-file/details/navigation/NCFileDetailsNavigator';
import { PartDetailsNavigator } from '@v2/pages/part/details/navigation/PartDetailsNavigator';
import { JobDetailsNavigator } from '@v2/pages/job/navigation/JobDetailsNavigator';
import { ToolsDetailsNavigator } from '@v2/pages/tools/details/navigation/ToolsDetailsNavigator';
import { ProductionOrderDetailsScreenName } from '@v2/pages/productionOrder/navigation/config';
import { ProductionOrderDetailsNavigator } from '@v2/pages/productionOrder/navigation/ProductionOrderDetailsNavigator';
import NCFileVersionDetails from '@components/ncFileVersions/components/NCFileVersionDetails';

const MachinesStack = createStackNavigator();

const MachinesNavigation = () => {
  return (
    <MachinesStack.Navigator initialRouteName={MACHINES_MAIN_SCREEN + MachinesScreen.LIVE} screenOptions={NAVIGATION_CONFIG}>
      <MachinesStack.Screen name={BatchDetailsScreenName} component={BatchDetailsNavigator} options={BOTTOM_SHEET_OPTIONS} />

      <MachinesStack.Screen name={NCFileDetailsScreenName} component={NCFileDetailsNavigator} options={BOTTOM_SHEET_OPTIONS} />

      <MachinesStack.Screen name={PartDetailsScreenName} component={PartDetailsNavigator} options={BOTTOM_SHEET_OPTIONS} />

      <MachinesStack.Screen name={JobDetailsScreenName} component={JobDetailsNavigator} options={BOTTOM_SHEET_OPTIONS} />

      <MachinesStack.Screen name={ProductionOrderDetailsScreenName} component={ProductionOrderDetailsNavigator} options={BOTTOM_SHEET_OPTIONS} />

      <MachinesStack.Screen name={ToolsDetailsScreenName} component={ToolsDetailsNavigator} options={BOTTOM_SHEET_OPTIONS} />

      <MachinesStack.Screen name="NCFileVersionDetails" component={NCFileVersionDetails} options={BOTTOM_SHEET_OPTIONS} />

      {machinesComponentsConfig.map(({ Component, name }) => (
        <MachinesStack.Screen key={name} name={name} component={Component} />
      ))}
    </MachinesStack.Navigator>
  );
};

export { MachinesNavigation };
